import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      t="1637286297960"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2118"
      width="32"
      height="32"
    >
      <path
        d="M503.703033 813.56936c-46.207391-46.468334-92.579535-92.77601-138.987494-139.046846-53.253878-53.101405-106.60497-106.105596-162.03849-161.265894 13.256932-14.214746 23.925922-26.339902 35.311227-37.750789 86.790692-86.987167 173.759439-173.795255 260.556271-260.775258 9.230222-9.250688 19.21769-18.279319 26.194592-29.123294 10.748808-16.706497 10.456143-34.985816-3.816932-49.699935-15.835663-16.324804-35.003212-16.83748-53.399187-4.134157-9.326413 6.437619-17.176195 15.123442-25.275663 23.211654-102.015442 101.884458-204.051349 203.744357-305.866223 305.829384-44.690852 44.810578-44.806485 56.637951-1.131777 100.44569 101.798501 102.099353 203.788359 204.00837 305.814034 305.879526 9.239432 9.224082 18.576077 18.642592 29.14683 26.173103 17.025769 12.129248 34.276664 9.720386 49.094138-4.454452 14.995529-14.343683 16.262382-32.148188 6.736425-49.446156C520.664334 829.64857 511.74008 821.654502 503.703033 813.56936z"
        fill="#8a8a8a"
        p-id="2119"
      />
      <path
        d="M869.6404 470.26855c-8.143471-0.444115-16.32992-0.140193-24.495904-0.140193-140.471288-0.004093-280.941554-0.062422-421.411819 0.028653-53.994752 0.034792-75.130118 11.865235-73.347518 42.243103 1.815345 30.940686 18.49626 41.438785 75.477019 40.093137 70.195735-1.660826 140.461055-0.398066 210.695676-0.396019 24.50102 0.001023 49.002041 0.020466 73.502038-0.002047 53.900607-0.050142 107.821681 0.731664 161.696706-0.499373 33.139771-0.7552 50.351781-16.655332 49.539276-41.37227C920.488485 485.695914 903.026788 472.078779 869.6404 470.26855z"
        fill="#8a8a8a"
        p-id="2119"
      />
    </svg>
  )
}
const RegisterBackIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
RegisterBackIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
RegisterBackIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default RegisterBackIcon
